export enum RequestSideEffectType {
  PATIENT_STATUS_UPDATE = 'PATIENT_STATUS_UPDATE',
}
